<template>
<div>
  <component 
    :is="`attribute-output-${finding.findable.type.cast_type}`"
    :findable="finding.findable"
  />
</div>
</template>
<script>

export default {
  
  props: {
    finding: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>